import React from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

const lexend = '"Lexend", sans-serif';
const sectionStyle = { fontFamily: lexend, fontOpticalSizing: 'auto', marginBottom: '1.5rem' };
const headingStyle = { fontFamily: lexend, fontOpticalSizing: 'auto', fontWeight: 700, color: '#1c3dfe', marginBottom: '0.5rem' };
const linkStyle = { color: '#1c3dfe', textDecoration: 'underline' };

export default function TermsOfServicePage() {
  return (
    <>
      <SiteHeader />
      <main style={{ paddingTop: '100px', paddingBottom: '3rem', minHeight: '100vh', background: '#fff' }}>
        <article style={{ maxWidth: '720px', margin: '0 auto', padding: '2rem 2rem 4rem' }}>
          <h1 style={{ ...headingStyle, fontSize: 'clamp(1.75rem, 4vw, 2.25rem)', marginBottom: '0.25rem' }}>
            NearStay – Terms of Service
          </h1>
          <p style={{ ...sectionStyle, color: '#666', fontSize: '0.95rem' }}>Last updated: 26 February 2026</p>

          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            These Terms of Service (&quot;Terms&quot;) govern your access to and use of the NearStay website, mobile app, and related services (collectively, the &quot;Service&quot;). By accessing or using NearStay, you agree to be bound by these Terms. If you do not agree to these Terms, do not use the Service.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>1. About NearStay</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            NearStay is a hotel discovery and area-matching platform that helps users explore neighbourhoods and accommodation options based on preferences such as safety, vibes, nightlife, cafés, restaurants, and other lifestyle factors. NearStay does not own, operate, manage, or control any hotels, accommodation providers, transport providers, or travel services. All bookings are made with third-party providers.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>2. Eligibility</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            You must be at least 18 years old to use NearStay. By using the Service, you confirm that you are legally able to enter into these Terms.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>3. How NearStay Works</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>NearStay provides:</p>
          <ul style={{ ...sectionStyle, paddingLeft: '1.5rem', lineHeight: 1.7, color: '#333' }}>
            <li>Area insights and scores</li>
            <li>Recommendations based on user preferences</li>
            <li>Links to third-party booking platforms</li>
            <li>General travel and neighbourhood information</li>
          </ul>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            NearStay is not a travel agency, does not provide accommodation itself, and does not guarantee availability, prices, quality, safety, or suitability of any location or hotel.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>4. No Safety or Suitability Guarantee</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>NearStay provides generalised area information only. You acknowledge and agree that:</p>
          <ul style={{ ...sectionStyle, paddingLeft: '1.5rem', lineHeight: 1.7, color: '#333' }}>
            <li>Area safety scores, vibes, and recommendations are subjective estimates</li>
            <li>Neighbourhoods can change rapidly</li>
            <li>Safety, comfort, noise levels, cleanliness, crime levels, and suitability vary by street, time of day, season, and personal circumstances</li>
            <li>What feels safe or enjoyable for one person may not be for another</li>
          </ul>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            NearStay does not guarantee that any area is safe, quiet, suitable, or appropriate for you. You are solely responsible for: researching locations independently; assessing personal safety; choosing where to stay; taking reasonable travel precautions. NearStay is not responsible for any harm, loss, inconvenience, discomfort, dissatisfaction, crime, injury, or negative experience arising from where you choose to stay or travel.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>5. Third-Party Bookings &amp; Services</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            When you click through from NearStay to book accommodation or services, you are dealing directly with a third-party provider. NearStay is not responsible for: booking errors; cancellations; overbookings; price changes; scams or fraudulent listings; hotel conditions; customer service disputes; refunds; lost or stolen property; safety incidents. Any issues with bookings must be resolved with the third-party provider.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>6. No Warranties</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            NearStay is provided &quot;as is&quot; and &quot;as available&quot;. We make no warranties, express or implied, including but not limited to: accuracy of area data; completeness of information; fitness for a particular purpose; reliability of recommendations; availability of listed accommodations; safety of locations. Use the Service at your own risk.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>7. Limitation of Liability</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            To the maximum extent permitted by law, NearStay, its founders, employees, and partners will not be liable for: personal injury; property damage; theft; assault; travel disruption; financial loss; missed flights; bad accommodation experiences; emotional distress; any indirect, incidental, or consequential damages. Even if NearStay was advised of the possibility of such damages.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>8. User Responsibility</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            You agree that you: use NearStay at your own discretion; will verify important details independently; will follow local laws and safety guidance; understand travel always carries risk; are responsible for your personal safety and choices.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>9. Prohibited Use</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            You may not: abuse or attempt to hack the platform; scrape data at scale; misuse recommendations; misrepresent yourself; use NearStay for unlawful purposes.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>10. Intellectual Property</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            All NearStay branding, content, designs, scores, and UX elements are owned by NearStay or licensed to NearStay. You may not copy, reuse, or redistribute them without permission.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>11. Termination</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            We may suspend or terminate access to NearStay at any time if you violate these Terms or misuse the platform.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>12. Changes to These Terms</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            We may update these Terms at any time. Continued use of NearStay after changes means you accept the updated Terms.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>13. Governing Law</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            These Terms are governed by the laws of the jurisdiction in which NearStay operates. (You can specify a country later once your company entity is final.)
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>14. Contact</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>For questions about these Terms, contact:</p>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            <strong>NearStay</strong><br />
            📧 garethpower92@gmail.com<br />
            🌐 <a href="https://nearstay.co" target="_blank" rel="noopener noreferrer" style={linkStyle}>https://nearstay.co</a>
          </p>

          <p style={{ marginTop: '2.5rem' }}>
            <Link to="/" style={{ color: '#1c3dfe', textDecoration: 'underline', fontFamily: lexend }}>← Back to NearStay</Link>
            {' · '}
            <a href="/terms-of-service.pdf" style={linkStyle} download>Download PDF</a>
          </p>
        </article>
      </main>
      <SiteFooter />
    </>
  );
}
